/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-02-02 20:52:38
 */
import React, { useRef, useState, useEffect } from 'react'
import './index.scss'
import { Spin, Layout } from 'antd'
import { useThrottleFn } from 'ahooks'
import Header from '../mainWrapper/Header'
import Members from './components/Members'
import PrivilegeCompare from './components/PrivilegeCompare'
import FixedMembers from './components/FixedMembers'
import VipPaymentModal from '../components/VipPaymentModal'
import sensor from '../../utils/sensors'
import { useAvailableVipKinds, usePrivilegeTracking } from './hooks'
import { VIP_KIND_NAMES } from './constants'
import { useParams } from 'react-router-dom'

export default function Privileges() {
  const pageRef = useRef<HTMLDivElement>(null)
  const [showFixedMembers, setShowFixedMembers] = useState(false)
  const [opacity, setOpacity] = useState(0)
  const searchParams = new URLSearchParams(window.location.search)
  const fromPlace = searchParams.get('fromPlace')

  const titleElRef = useRef<Element | null>(null)

  // 使用 ahooks 的 useThrottleFn 封装滚动处理函数
  const { run: handleScroll } = useThrottleFn(
    () => {
      const page = pageRef.current
      if (!page) return

      // 优先使用缓存的 DOM 引用
      if (!titleElRef.current) {
        titleElRef.current = document.querySelector('.compareTitle')
      }
      const titleEl = titleElRef.current
      if (!titleEl) return

      const pageRect = page.getBoundingClientRect()
      const titleRect = titleEl.getBoundingClientRect()
      // 计算标题距离容器顶部的距离
      const distance = titleRect.top - pageRect.top

      // 距离 > 200px 时卸载
      // 距离 <= 200px 时挂载
      // 动画区间：100px - 200px，透明度 1 - 0

      if (distance > 200) {
        setShowFixedMembers(false)
        setOpacity(0)
      } else {
        setShowFixedMembers(true)
        // 200px -> 0, 100px -> 1
        let op = (200 - distance) / 100
        // 限制在 0-1 之间
        if (op < 0) op = 0
        if (op > 1) op = 1
        setOpacity(op)
      }
    },
    { wait: 20 }
  )

  const { defaultSelected } = useAvailableVipKinds()

  const { durations, visibleCategories, onInteraction } = usePrivilegeTracking()

  const handleEventTrack = (clickItem: string, vipKind?: number) => {
    const params: any = {
      clickItem,
      string2: defaultSelected !== undefined ? VIP_KIND_NAMES[defaultSelected] : '',
      track_sign: 'avip.b7980.click.vip_b7980_click',
      requirement_id: 801,
      fromPlace
    }
    if (clickItem === '开通或升级' || clickItem === '点击企业级会员') {
      params.list1 = visibleCategories
      params.list2 = Object.keys(durations).map((k) => ({ [k]: durations[k] }))
    }
    if (vipKind) {
      params.string1 = VIP_KIND_NAMES[vipKind]
    }
    sensor.track('vip_b7980_click', params)
  }

  useEffect(() => {
    handleEventTrack('enterPage')
  }, [])

  useEffect(() => {
    const page = pageRef.current
    if (!page) return

    page.addEventListener('scroll', handleScroll)
    // 初始化检查
    handleScroll()

    return () => {
      page.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <Spin spinning={false} size="large" className="loading">
      <Layout className="PrivilegesPage">
        <Header />
        <div className="page" ref={pageRef} onScroll={onInteraction}>
          <Members handleEventTrack={handleEventTrack} />
          <PrivilegeCompare />
          {showFixedMembers && (
            <FixedMembers
              style={{ opacity }}
              handleEventTrack={handleEventTrack}
            />
          )}
        </div>
        <VipPaymentModal />
      </Layout>
    </Spin>
  )
}
